export default async function getServerDateOffset() {
  const requestDate = new Date()
  const {headers, ok, statusText} = await fetch(window.location, {
    cache: `no-store`,
    method: `HEAD`,
  })
  const responseDate = new Date()

  if (!ok) {
    throw new Error(`Bad date sample from server: ${statusText}`)
  }

  const serverDate = new Date(headers.get(`Date`))
  const offset = (responseDate - requestDate) / 2
  const currentDate = new Date()
  return serverDate.getTime() + offset - currentDate.getTime()
}